/* ==========================================================================
   PDP — choix du pack + panachage (Option B : combinaisons prédéfinies).
   Port Dawn : variant picker natif (option « Panachage ») + cart AJAX.
   URL : produit.html?pack=decouverte|potager|recolte
   ========================================================================== */
(() => {
  const PACKS = {
    decouverte: {
      id: 'pack-decouverte',
      nom: 'Pack Découverte',
      boxes: 4,
      prix: 13.90,
      pitch: 'Pour faire goûter et trouver sa préférée.',
      /* composition fixe : pas de panachage (Option B) */
      mixes: [{ t: 2, c: 2, label: '2 Tomate & Origan + 2 Carotte & Cumin', fixe: true }],
    },
    potager: {
      id: 'pack-potager',
      nom: 'Pack Potager',
      boxes: 8,
      prix: 27.90,
      pitch: 'Le format de la maison.',
      mixes: [
        { t: 8, c: 0 }, { t: 6, c: 2 }, { t: 4, c: 4 }, { t: 2, c: 6 }, { t: 0, c: 8 },
      ],
    },
    recolte: {
      id: 'pack-recolte',
      nom: 'Pack Récolte',
      boxes: 12,
      prix: 41.90,
      pitch: 'La réserve du mois.',
      mixes: [
        { t: 12, c: 0 }, { t: 8, c: 4 }, { t: 6, c: 6 }, { t: 4, c: 8 }, { t: 0, c: 12 },
      ],
    },
  };
  const SEUIL_RELAIS = 35;
  // Point relais offert UNIQUEMENT si le pack atteint le seuil (A-PDP-01 : plus de badge faux).
  const offert = (p) => p.prix >= SEUIL_RELAIS;
  const euros = (n) => n.toFixed(2).replace('.', ',') + ' €';
  const mixLabel = (m) => m.label || `${m.t} Tomate & Origan + ${m.c} Carotte & Cumin`;
  const mixCourt = (m) => m.t === 0 ? 'Tout Carotte & Cumin'
    : m.c === 0 ? 'Tout Tomate & Origan'
    : `${m.t} Tomate · ${m.c} Carotte`;

  const els = {
    title: document.querySelector('[data-pdp-title]'),
    prix: document.querySelector('[data-pdp-prix]'),
    relais: document.querySelector('[data-pdp-relais]'),
    packRadios: document.querySelector('[data-pack-radios]'),
    mixOptions: document.querySelector('[data-mix-options]'),
    mixFixe: document.querySelector('[data-mix-fixe]'),
    crateBoxes: document.querySelector('[data-crate-boxes]'),
    crateCaption: document.querySelector('[data-crate-caption]'),
    franco: document.querySelector('[data-pdp-franco]'),
    sticky: document.querySelector('[data-pdp-sticky]'),
    stickyNom: document.querySelector('[data-sticky-nom]'),
    stickyPrix: document.querySelector('[data-sticky-prix]'),
  };
  if (!els.packRadios) return;

  const param = new URLSearchParams(location.search).get('pack');
  const state = {
    pack: PACKS[param] ? param : 'potager',
    mix: 0,
  };
  if (PACKS[state.pack].mixes.length > 1) {
    state.mix = Math.floor(PACKS[state.pack].mixes.length / 2); // équilibré par défaut
  }

  /* ---------- Rendus ---------- */
  const renderPacks = () => {
    els.packRadios.innerHTML = Object.entries(PACKS).map(([key, p]) => `
      <label class="pdp-pack-radio${key === state.pack ? ' is-checked' : ''}">
        <input type="radio" name="pack" value="${key}" ${key === state.pack ? 'checked' : ''}>
        <span class="pdp-pack-radio-body">
          <strong>${p.nom.replace('Pack ', '')}</strong>
          <span>${p.boxes} boîtes · ${euros(p.prix)}</span>
          <small>${offert(p) ? 'point relais offert' : p.pitch.toLowerCase()}</small>
        </span>
      </label>`).join('');
    els.packRadios.querySelectorAll('input').forEach((input) => {
      input.addEventListener('change', () => {
        state.pack = input.value;
        state.mix = PACKS[state.pack].mixes.length > 1
          ? Math.floor(PACKS[state.pack].mixes.length / 2) : 0;
        history.replaceState(null, '', `produit.html?pack=${state.pack}`);
        renderAll();
      });
    });
  };

  const renderMixes = () => {
    const p = PACKS[state.pack];
    const panachable = p.mixes.length > 1;
    els.mixFixe.hidden = panachable;
    els.mixOptions.hidden = !panachable;
    if (!panachable) { els.mixOptions.innerHTML = ''; return; }
    els.mixOptions.innerHTML = p.mixes.map((m, i) => `
      <label class="pdp-mix-radio${i === state.mix ? ' is-checked' : ''}">
        <input type="radio" name="mix" value="${i}" ${i === state.mix ? 'checked' : ''}>
        <span class="pdp-mix-dots" aria-hidden="true">
          ${'<i class="pdp-minibox pdp-minibox--t"></i>'.repeat(m.t)}${'<i class="pdp-minibox pdp-minibox--c"></i>'.repeat(m.c)}
        </span>
        <span>${mixCourt(m)}</span>
      </label>`).join('');
    els.mixOptions.querySelectorAll('input').forEach((input) => {
      input.addEventListener('change', () => { state.mix = Number(input.value); renderAll(); });
    });
  };

  const renderCrate = () => {
    const p = PACKS[state.pack];
    const m = p.mixes[state.mix];
    els.crateBoxes.style.setProperty('--crate-cols', p.boxes > 4 ? 4 : 2);
    // --ci : index par boîte → cascade de l'apparition (animation-delay, 20-pdp.css)
    const box = (cls, n, offset) =>
      Array.from({ length: n }, (_, i) => `<span class="pdp-crate-box ${cls}" style="--ci:${offset + i}"></span>`).join('');
    els.crateBoxes.innerHTML = box('pdp-crate-box--t', m.t, 0) + box('pdp-crate-box--c', m.c, m.t);
    els.crateCaption.textContent = `${p.nom} — ${mixCourt(m)}`;
  };

  const renderBuy = () => {
    const p = PACKS[state.pack];
    els.title.textContent = p.nom;
    document.title = `${p.nom} — Didibou · Le Boudoir du Potager`;
    els.prix.textContent = euros(p.prix);
    els.relais.hidden = !offert(p);
    els.stickyNom.textContent = p.nom;
    els.stickyPrix.textContent = euros(p.prix);
    const reste = SEUIL_RELAIS - p.prix;
    els.franco.textContent = reste > 0
      ? `Plus que ${euros(reste)} pour le point relais offert (dès ${SEUIL_RELAIS} €).`
      : '';
  };

  const renderAll = () => { renderPacks(); renderMixes(); renderCrate(); renderBuy(); };
  renderAll();

  /* ---------- Ajout panier (+ feedback complice sur le bouton) ---------- */
  const add = (e) => {
    const p = PACKS[state.pack];
    const m = p.mixes[state.mix];
    window.didibouCart.add(p.id, p.mixes.length > 1 || m.fixe ? mixLabel(m) : '');
    const btn = e?.currentTarget;
    if (btn && !btn.dataset.adding) {
      btn.dataset.adding = '1';
      const original = btn.textContent;
      btn.classList.add('is-added');
      btn.textContent = 'Hop, dans la cagette !';
      setTimeout(() => {
        btn.classList.remove('is-added');
        btn.textContent = original;
        delete btn.dataset.adding;
      }, 1500);
    }
  };
  document.querySelector('[data-pdp-atc]')?.addEventListener('click', add);
  document.querySelector('[data-pdp-atc-sticky]')?.addEventListener('click', add);

  /* ---------- Sticky ATC mobile : visible une fois le bouton principal passé ---------- */
  const mainBtn = document.querySelector('[data-pdp-atc]');
  if (els.sticky && mainBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver((entries) => {
      els.sticky.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0;
    }).observe(mainBtn);
  }
})();
